import { defineMessages } from "react-intl";

const messages = defineMessages({
  unsubscribedLabel: {
    id: "emailSubscriptionStatusTag.unsubscribedLabel",
    defaultMessage: "Unsubscribed",
    description: "Email subscription unsubscribed status tag label",
  },
});

export default messages;
